import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDiscord } from "@fortawesome/free-brands-svg-icons"



const Footer = () => {
    return (
        <footer id="footer" className="navbar bg-dark">
            <ul className="icons">
                <li><a className="icon" href="https://discord.gg/rTQhWEBJwt" target="_blank"><FontAwesomeIcon icon={faDiscord} /> <em id="footer-text" className="d-inline">Join our community</em></a></li>
            </ul>
        </footer>
    );
};

export default Footer